import { render, staticRenderFns } from "./ResetPassword3.vue?vue&type=template&id=c31584b8&scoped=true&"
import script from "./ResetPassword3.vue?vue&type=script&lang=js&"
export * from "./ResetPassword3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31584b8",
  null
  
)

export default component.exports